import React from 'react'
import {
    Datagrid,
    EditButton,
    List,
    TextField,
    TextInput,
    Filter,
    NumberInput,
    ShowButton, CardActions, WithPermissions, CreateButton, ExportButton,
} from 'react-admin';
import TextFieldColor from "../componentes/TextFieldColor";
import withStyles from "@material-ui/core/styles/withStyles";

const Filtros = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" variant="outlined" source="q" alwaysOn/>


        <TextInput label="Código" source="secuencia_tipo" alwaysOn/>
        <TextInput label="Descripción" source="contratacion_d" alwaysOn/>
        <NumberInput label="Monto Desde Pesos - Desde" source="monto_desde_pesos_desde"
                     style={{textAlign: 'right', margin: '1em'}}
                     options={{minimumFractionDigits: 2}}/>
        <NumberInput label="Monto Desde Pesos - Hasta" source="monto_desde_pesos_hasta"
                     style={{textAlign: 'right', margin: '1em'}}
                     options={{minimumFractionDigits: 2}}/>
        <NumberInput label="Monta Hasta Pesos - Desde" source="monta_hasta_pesos_desde"
                     style={{textAlign: 'right', margin: '1em'}}
                     options={{minimumFractionDigits: 2}}/>
        <NumberInput label="Monta Hasta Pesos - Hasta" source="monta_hasta_pesos_hasta"
                     style={{textAlign: 'right', margin: '1em'}}
                     options={{minimumFractionDigits: 2}}/>
        <NumberInput label="Ultimo Nro Usado - Desde" source="ultimo_nro_usado_desde"
                     style={{textAlign: 'right', margin: '1em'}}
                     options={{minimumFractionDigits: 2}}/>
        <NumberInput label="Ultimo Nro Usado - Hasta" source="ultimo_nro_usado_hasta"
                     style={{textAlign: 'right', margin: '1em'}}
                     options={{minimumFractionDigits: 2}}/>

    </Filter>
);


const styles = {
    flex: {display: 'flex'},
    flexColumn: {display: 'flex', flexDirection: 'column'},
    leftCol: {flex: 1, marginRight: '1em'},
    rightCol: {flex: 1, marginLeft: '1em'},
    singleCol: {marginTop: '2em', marginBottom: '2em'},
};

const role_auxiliar_editar_permissions = ({permissions}) => {
    var w_role_control = ''
    var w_permissions_control = permissions
    if (w_permissions_control == null) {
    } else {
        var w_role_auxiliar_editar = w_permissions_control.indexOf('ROLE_AUXILIAR_EDITAR')
        if (w_role_auxiliar_editar === -1) {
        } else {
            w_role_control = 'ROLE_AUXILIAR_EDITAR'
        }
    }

    return w_role_control
}

const role_auxiliar_crear_permissions = ({permissions}) => {
    var w_role_control = ''
    var w_permissions_control = permissions
    if (w_permissions_control == null) {
    } else {
        var w_role_auxiliar_crear = w_permissions_control.indexOf('ROLE_AUXILIAR_CREAR')
        if (w_role_auxiliar_crear === -1) {
        } else {
            w_role_control = 'ROLE_AUXILIAR_CREAR'
        }
    }

    return w_role_control
}



const role_exportar_csv = ({permissions}) => {
    var w_role_control = '';
    var w_permissions_control = permissions;
    if (w_permissions_control == null) {
    } else {
        var w_role_exportar_csv = w_permissions_control.indexOf('ROLE_EXPORTAR_CSV');
        if (w_role_exportar_csv === -1) {
        } else {
            w_role_control = 'ROLE_EXPORTAR_CSV'
        }
    }
    return w_role_control
};


const PostActions = ({resource, filters, displayedFilters, filterValues, basePath, showFilter}) => (
    <CardActions>
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        <WithPermissions
            render={({permissions}) => (
                role_auxiliar_crear_permissions({permissions}) === 'ROLE_AUXILIAR_CREAR'
                    ?
                    <CreateButton/>
                    : null
            )}
        />

        <WithPermissions
            render={({permissions}) => (
                role_exportar_csv({permissions}) === 'ROLE_EXPORTAR_CSV'
                    ?
                    <ExportButton/>
                    : null

            )}
        />

    </CardActions>
);

export const ContratacionSecuenciaTipoList = withStyles(styles)(({classes, permissions, ...props}) => {
    return (
        <List {...props} title="Listado de Contratacion Secuencia Tipo"
              bulkActionButtons={false}
              perPage={25}
              actions={<PostActions/>}
              filters={<Filtros/>}>

            <Datagrid expand={false}>

                <TextField label="Código" source="secuencia_tipo"/>
                <TextField label="Descripción" source="secuencia_tipo_d"/>
                <TextFieldColor label="Color"/>
                <ShowButton/>
                {role_auxiliar_editar_permissions({permissions}) === 'ROLE_AUXILIAR_EDITAR' &&
                <EditButton/>
                }
            </Datagrid>
        </List>
    )
});


export default ContratacionSecuenciaTipoList;
